import { Action } from "redux";
import { IAuctionFilters } from "..";
import { IAuction } from "../../services";

export interface IAuctionCalendarState {
  loading?: boolean;
  data?: IAuction[];
  initialFilters?: IAuctionFilters;
  currentFilters?: IAuctionFilters;
  exceptionMessage?: string;
}

export enum AuctionActionCalendarEnum {
  FetchFiltersAndAuctionCalendar = "@@auction/FETCH_FILTERS_AND_AUCTION_CALENDAR",
  FetchedFiltersAndAuctionCalendarSuccess = "@@auction/FETCHED_FILTERS_AND_AUCTION_CALENDAR_SUCCESS",
  FetchedFiltersAndAuctionCalendarFailed = "@@auction/FETCHED_FILTERS_AND_AUCTION_CALENDAR_FAILED",
  UpdateAuctionCalendarCorridorFilterValue = "@@auction/UPDATE_AUCTION_CALENDAR_CORRIDOR_FILTER_VALUE",
  UpateAuctionCalendarInterconnectorFilterValue = "@@auction/UPDATE_AUCTION_CALENDAR_INTERCONNECTOR_FILTER_VALUE",
  UpateAuctionCalendarProductFilterValue = "@@auction/UPDATE_AUCTION_CALENDAR_PRODUCT_FILTER_VALUE",
  UpateAuctionCalendarIsShowFilterValue = "@@auction/UPDATE_AUCTION_CALENDAR_IS_SHOW_FILTER_VALUE",
  UpdateAuctionCalendarExchangeFilterValue = "@@auction/UPDATE_AUCTION_CALENDAR_EXCHANGE_FILTER_VALUE"
}

export interface IFetchFiltersAndAuctionCalendarAction
  extends Action<typeof AuctionActionCalendarEnum.FetchFiltersAndAuctionCalendar> {
  state?: IAuctionCalendarState;
}
export interface IFetchedFiltersAndAuctionCalendarSuccessAction
  extends Action<typeof AuctionActionCalendarEnum.FetchedFiltersAndAuctionCalendarSuccess> {
  state?: IAuctionCalendarState;
}

export interface IFetchedFiltersAndAuctionCalendarFailedAction
  extends Action<typeof AuctionActionCalendarEnum.FetchedFiltersAndAuctionCalendarFailed> {
  state?: IAuctionCalendarState;
}

export interface IUpdateAuctionCalendarCorridorFilterValueAction
  extends Action<typeof AuctionActionCalendarEnum.UpdateAuctionCalendarCorridorFilterValue> {
  state?: IAuctionCalendarState;
}

export interface IUpdateAuctionCalendarProductFilterValueAction
  extends Action<typeof AuctionActionCalendarEnum.UpateAuctionCalendarProductFilterValue> {
  state?: IAuctionCalendarState;
}

export interface IUpdateAuctionCalendarIsShowFilterValueAction
  extends Action<typeof AuctionActionCalendarEnum.UpateAuctionCalendarIsShowFilterValue> {
  state?: IAuctionCalendarState;
}

export interface IUpdateAuctionCalendarInterconnectorFilterValueAction
  extends Action<typeof AuctionActionCalendarEnum.UpateAuctionCalendarInterconnectorFilterValue> {
  state?: IAuctionCalendarState;
}

export interface IUpdateAuctionCalendarExchangeFilterValueAction
  extends Action<typeof AuctionActionCalendarEnum.UpdateAuctionCalendarExchangeFilterValue> {
  state?: IAuctionCalendarState;
}

export type AuctionCalendarActions =
  | IFetchFiltersAndAuctionCalendarAction
  | IFetchedFiltersAndAuctionCalendarSuccessAction
  | IFetchedFiltersAndAuctionCalendarFailedAction
  | IUpdateAuctionCalendarCorridorFilterValueAction
  | IUpdateAuctionCalendarProductFilterValueAction
  | IUpdateAuctionCalendarIsShowFilterValueAction
  | IUpdateAuctionCalendarInterconnectorFilterValueAction
  | IUpdateAuctionCalendarExchangeFilterValueAction;
  
